// @flow

import styled from 'styled-components';

export const FooterRoot = styled.footer`
  border-top: 1px solid ${props => props.theme.colors.neutral[150]};
  padding: 16px;
  flex-shrink: 0;
`;

export const FooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 12px;
  color: ${props => props.theme.colors.neutral[500]};
`;

export const EbanxLogo = styled.img`
  width: 46px;
  height: auto;
`;
